import { ErrorTypes, RecordingHostError } from '../types/ErrorTypes';
export const getNetworkErrorResult = (error, isZoomSource) => {
  let networkStatus = undefined;
  if (error && error instanceof Error && 'status' in error) {
    networkStatus = `${error.status}`;
  }
  let errorType = ErrorTypes.REFRESH_AUTH_ERROR;
  if (networkStatus === '404' && isZoomSource) {
    errorType = RecordingHostError.ZOOM_RECORDING_NOT_FOUND;
  }
  return {
    networkStatus,
    errorType
  };
};